import { render } from "./eventtype-from.vue?vue&type=template&id=3a41d105"
import script from "./eventtype-from.vue?vue&type=script&lang=js"
export * from "./eventtype-from.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__